var map = {
	"./10.jpg": 1578,
	"./11.jpg": 1579,
	"./12.jpg": 1580,
	"./7.jpg": 1581,
	"./8.jpg": 1582,
	"./9.jpg": 1583,
	"./document.png": 1584,
	"./video-play.png": 1585
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1730;